import { FormatNumberOptions } from "@formatjs/intl/src/types";

export const config = {
    currencyFormatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: "currency",
        currency: "USD",
    } as FormatNumberOptions,
    customFormatOptions: (fractionDigits) => ({
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }),
    utcDateFormatOptions: {
        timeZone: "UTC",
        year: "2-digit",
        month: "numeric",
        day: "numeric",
    },
    nonGroupedNumberFormatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: false,
    } as FormatNumberOptions,
    numberFormatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    } as FormatNumberOptions,
    decimalFormatOptions: {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    } as FormatNumberOptions,
    wholeNumberFormatOptions: {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    } as FormatNumberOptions,
};
